import { type MouseEvent } from 'react';

export type BarProps = Readonly<{
  x: number;
  y: number;
  width: number;
  height: number;
  fill?: string;
  className?: string;
  innerRef?: (element: SVGRectElement | null) => void;
  onMouseMove?: (event: MouseEvent<SVGRectElement>) => void;
  onMouseLeave?: (event: MouseEvent<SVGRectElement>) => void;
}>;

export const Bar = ({ innerRef, ...props }: BarProps) => <rect ref={innerRef} {...props} />;
